import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/sumeet/webdesign/prateeksha.com/next.js/src/components/CallToAction.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/sumeet/webdesign/prateeksha.com/next.js/src/components/CallToBoost.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/sumeet/webdesign/prateeksha.com/next.js/src/components/CounterSection.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/sumeet/webdesign/prateeksha.com/next.js/src/components/FaqsSection.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/sumeet/webdesign/prateeksha.com/next.js/src/components/HeroSection.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/sumeet/webdesign/prateeksha.com/next.js/src/components/IntroSection.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/sumeet/webdesign/prateeksha.com/next.js/src/components/LatestBlog.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/sumeet/webdesign/prateeksha.com/next.js/src/components/Services.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/sumeet/webdesign/prateeksha.com/next.js/src/components/TechnologySection.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/sumeet/webdesign/prateeksha.com/next.js/src/components/WhatIsIncludedSection.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/sumeet/webdesign/prateeksha.com/next.js/src/components/WhyChooseUsSection.jsx");
